import { render, staticRenderFns } from "./FileLinkControl.vue?vue&type=template&id=4fbbe610"
import script from "./FileLinkControl.vue?vue&type=script&lang=ts"
export * from "./FileLinkControl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports